import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('po/inter-branch-transfer/drafts', { params })
  },

  async show (id) {
    return axios.get(`po/inter-branch-transfer/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/inter-branch-transfer/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/inter-branch-transfer/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/inter-branch-transfer/drafts/${data.id}`, { data })
  }
}

export default DraftService
